import { __resetStyles, mergeClasses, shorthands } from '@griffel/react';
export const toastFooterClassNames = {
  root: 'fui-ToastFooter'
};
/**
 * Styles for the root slot
 */
const useRootBaseClassName = /*#__PURE__*/__resetStyles("r1u6izx1", null, [".r1u6izx1{padding-top:16px;grid-column-start:2;grid-column-end:3;display:flex;align-items:center;column-gap:14px;row-gap:14px;}"]);
/**
 * Apply styling to the ToastFooter slots based on the state
 */
export const useToastFooterStyles_unstable = state => {
  const rootBaseClassName = useRootBaseClassName();
  state.root.className = mergeClasses(toastFooterClassNames.root, rootBaseClassName, state.root.className);
  return state;
};
//# sourceMappingURL=useToastFooterStyles.styles.js.map